import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CardioMeta } from '../models/cardioMeta';

@Injectable({
  providedIn: 'root',
})
export class CardioService {
  
  private api = '/api/CardioMeta';

  constructor(private http: HttpClient) { }

  // =====================
  // READ (User/Admin)
  // =====================
  getAll(): Observable<CardioMeta[]> {
    return this.http.get<CardioMeta[]>(this.api);
  }

  getById(id: number): Observable<CardioMeta> {
    return this.http.get<CardioMeta>(`${this.api}/${id}`);
  }

  // =====================
  // WRITE (Admin only no backend)
  // =====================
  create(model: CardioMeta): Observable<CardioMeta> {
    return this.http.post<CardioMeta>(this.api, model);
  }

  update(model: CardioMeta): Observable<void> {
    return this.http.put<void>(`${this.api}/${model.id}`, model);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }
}
